module.exports = __webpack_public_path__ + "img/save-form.01efd304.gif";